var map = {
	"./223.jpg": 432,
	"./262.jpg": 433,
	"./273.jpg": 434,
	"./296.jpg": 435,
	"./322.jpg": 436,
	"./332.jpg": 437,
	"./336.jpg": 438,
	"./338.jpg": 439,
	"./5.jpg": 440,
	"./nalsoft.png": 441,
	"./news2.jpg": 442,
	"./news3.jpg": 443,
	"./news4.jpg": 444,
	"./news5.jpg": 445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 195;